export default __webpack_public_path__ + "static/media/icono-resumen-diario.c99a1034.png";